///Filter events
(function () {
  function emitFiltersUpdated() {
    document.dispatchEvent(new CustomEvent('filters:updated', { detail: { source: 'url' } }));
  }

  // Patch pushState & replaceState
  ['pushState', 'replaceState'].forEach(method => {
    const orig = history[method];
    history[method] = function () {
      const result = orig.apply(this, arguments);
      emitFiltersUpdated();
      return result;
    };
  });

  // Handle back/forward navigation
  window.addEventListener('popstate', emitFiltersUpdated);
})();

///move small banners
function moveAllBanners() {
  const grid = document.querySelector('.product-grid-container ul, .product-grid, [data-collection-grid]'); 
    if (!grid) {
      return;
    }
    banners = document.querySelectorAll('.collection-promo-banner-small');  
    cards = document.querySelectorAll('.prd_crd');
        
    banners.forEach(banner => {
      pos = parseInt(banner.dataset.gridPosition || '0', 10);
      pos += 1;
      cards.forEach(card => {
        const cardIndex = parseInt(card.dataset.index || '0', 10);
        if (cardIndex === pos) {
          card.insertAdjacentElement('beforebegin', banner);
          banner.classList.remove('hide_banner');
        }
      
    });
    //large banners
    lg_banners = document.querySelectorAll('.collection-promo-banner-large');
    lg_banners.forEach(banner => {
      lg_pos = parseInt(banner.dataset.gridPosition || '0', 10);
      lg_pos += 1;
      cards.forEach(lg_card => {
        const lg_cardIndex = parseInt(lg_card.dataset.index || '0', 10);
        if (lg_cardIndex === lg_pos) {
          lg_card.insertAdjacentElement('beforebegin', banner);
          banner.classList.remove('hide_banner');
        }
      });
    });
    });
}

function infiniteScroll() {
    ////////////// Infinite Scroll for Collection Page///////////////////////
  let loadMoreBtn = document.getElementById('load-more');
  let productGrid = document.getElementById('product-grid');
  let page = 2;  // Start loading from page 2
  let loading = false;

  window.addEventListener('scroll', function() {
    if (loading) return;

    // When user reaches near bottom of the page
    if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight - 500) {
      loading = true;
      loadMoreBtn.style.display = 'block';  // Show loading indicator or button

      fetch(`${window.location.pathname}?page=${page} #product-grid`)
        .then(response => response.text())
        .then(data => {
          let parser = new DOMParser();
          let htmlDoc = parser.parseFromString(data, 'text/html');
          let newProducts = htmlDoc.querySelectorAll('#product-grid > *');

          if (newProducts.length > 0) {
            newProducts.forEach(el => productGrid.appendChild(el));
            page++;
            loading = false;
            loadMoreBtn.style.display = 'none';
          } else {
            // No more products to load
            window.removeEventListener('scroll', arguments.callee);
            loadMoreBtn.style.display = 'none';
          }
        })
        .catch(() => {
          // On error, stop loading
          loading = false;
          loadMoreBtn.style.display = 'none';
        });
    }
});
}

///////////////BUTOANE SORTARE///////////////////////
 /**
  * Quick sort/filter pills, rendered by snippets/collection-quick-filters.liquid.
  *
  * Two shapes:
  *   sort pill    data-query="sort_by=best-selling"
  *   filter pill  data-filter-param="filter.p.m.custom.try_on" data-filter-values='["1"]'
  *
  * Filter pills carry the values Liquid resolved from the live result set, so a
  * pill only exists when it has products behind it and the browser never has to
  * guess which values apply.
  */

 /**
  * @typedef {HTMLElement & {
  *   updateFiltersByURL?: (url: string) => void;
  * }} FacetsFormComponentElement
  */

 /**
  * @typedef {{ type: 'sort', value: string }} QuickSort
  * @typedef {{ type: 'filter', param: string, values: string[] }} QuickFilter
  * @typedef {QuickSort | QuickFilter} QuickAction
  */

 /**
  * @param {HTMLButtonElement} button
  * @returns {QuickAction | null}
  */
 function readQuickAction(button) {
    const param = button.dataset.filterParam;

    if (param) {
      let values = [];

      try {
        const parsed = JSON.parse(button.dataset.filterValues || '[]');
        if (Array.isArray(parsed)) values = parsed.map(String).filter(Boolean);
      } catch {
        values = [];
      }

      return values.length > 0 ? { type: 'filter', param, values } : null;
    }

    // Legacy shape, still used by sort pills and by any button authored in admin.
    const query = button.dataset.query || '';
    const separatorIndex = query.indexOf('=');
    if (separatorIndex === -1) return null;

    const queryParam = query.slice(0, separatorIndex);
    const value = query.slice(separatorIndex + 1);
    if (!queryParam || !value) return null;

    return queryParam === 'sort_by'
      ? { type: 'sort', value }
      : { type: 'filter', param: queryParam, values: [value] };
  }

 /**
  * @param {QuickAction} action
  * @param {URL} url
  * @returns {boolean}
  */
 function isQuickActionActive(action, url) {
    if (action.type === 'sort') return url.searchParams.get('sort_by') === action.value;

    const currentValues = url.searchParams.getAll(action.param);
    return action.values.some((value) => currentValues.includes(value));
  }

 /**
  * @param {HTMLElement} trigger
  * @param {QuickAction} action
  * @returns {FacetsFormComponentElement | null}
  */
 function getFacetsFormComponent(trigger, action) {
    const section = trigger.closest('.shopify-section');
    const formComponents = Array.from(
      (section || document).querySelectorAll('facets-form-component')
    ).filter(
      /** @returns {component is FacetsFormComponentElement} */
      (component) => component instanceof HTMLElement
    );

    const visibleComponents = formComponents.filter((component) => {
      if (component.closest('dialog:not([open])')) return false;
      return component.offsetParent !== null;
    });

    const componentsToCheck = visibleComponents.length > 0 ? visibleComponents : formComponents;

    // Sorting is submitted through the form that owns the matching radio input.
    if (action.type === 'sort') {
      const owner = componentsToCheck.find((component) =>
        component.querySelector(`form input[name="sort_by"][value="${action.value}"]`)
      );

      if (owner) return owner;
    }

    return componentsToCheck[0] || null;
  }

 /**
  * @param {HTMLElement} trigger
  * @param {QuickAction} action
  */
 function applyQuickAction(trigger, action) {
    const url = new URL(window.location.href);
    const shouldEnable = !isQuickActionActive(action, url);

    if (action.type === 'sort') {
      if (shouldEnable) {
        url.searchParams.set('sort_by', action.value);
      } else {
        url.searchParams.delete('sort_by');
      }
    } else {
      // Keep the values the shopper picked in the filter drawer, drop only ours.
      const keptValues = url.searchParams
        .getAll(action.param)
        .filter((value) => !action.values.includes(value));

      url.searchParams.delete(action.param);
      keptValues.forEach((value) => url.searchParams.append(action.param, value));

      if (shouldEnable) {
        action.values.forEach((value) => url.searchParams.append(action.param, value));
      }
    }

    // The result set changes, so the page the shopper was on no longer applies.
    url.searchParams.delete('page');

    // Update the relevant facets component directly from the merged URL so
    // existing filters remain intact when quick pills are used.
    const facetsComponent = getFacetsFormComponent(trigger, action);

    if (facetsComponent && typeof facetsComponent.updateFiltersByURL === 'function') {
      facetsComponent.updateFiltersByURL(url.toString());
    } else {
      window.location.href = url.toString();
    }
  }

 function syncQuickButtonsState() {
    const url = new URL(window.location.href);

    document.querySelectorAll('.btn_custom').forEach((button) => {
      if (!(button instanceof HTMLButtonElement)) return;

      const action = readQuickAction(button);
      const isActive = action ? isQuickActionActive(action, url) : false;

      button.classList.toggle('btn_custom--active', isActive);
      button.setAttribute('aria-pressed', String(isActive));
    });
  }

 let syncQuickButtonsFrame = 0;

 function scheduleQuickButtonsStateSync() {
    if (syncQuickButtonsFrame) cancelAnimationFrame(syncQuickButtonsFrame);

    syncQuickButtonsFrame = requestAnimationFrame(() => {
      syncQuickButtonsFrame = 0;
      syncQuickButtonsState();
    });
  }

 function initQuickButtons() {
    // The script tag lives inside the collection/search section, so a section
    // re-render can hand it to the browser a second time. Wire the listeners once.
    if (window.__quickButtonsInitialized) return;
    window.__quickButtonsInitialized = true;

    scheduleQuickButtonsStateSync();

    document.addEventListener('click', (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;

      const button = target.closest('.btn_custom');
      if (!(button instanceof HTMLButtonElement)) return;

      const action = readQuickAction(button);
      if (!action) return;

      event.preventDefault();

      applyQuickAction(button, action);
      scheduleQuickButtonsStateSync();
    });

    document.addEventListener('filters:updated', scheduleQuickButtonsStateSync);

    // The section is re-rendered through morph, which fires no event of its own.
    if (document.body) {
      new MutationObserver(scheduleQuickButtonsStateSync).observe(document.body, {
        childList: true,
        subtree: true,
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initQuickButtons);
  } else {
    initQuickButtons();
  }
